import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import { useTheme } from '@mui/material';

const SelectEstadoPreServicio = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    disabled,
    defaultProps,
    isMulti,
    restringir,
    negativaFO,
    negativaRF,
    negativaRFSC,
    negativaFOSC
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [selectedValue, setSelectedValue] = useState(value);
    const [options, setOptions] = useState([
        {
            value: 'EN ESPERA DE DA',
            label: 'EN ESPERA DE DA'
        },
        {
            value: 'FECHA PENDIENTE DE ASIGNAR',
            label: 'FECHA PENDIENTE DE ASIGNAR'
        },
        {
            value: 'FECHA ASIGNADA',
            label: 'FECHA ASIGNADA'
        },
        {
            value: 'NO LE INTERESA',
            label: 'NO LE INTERESA'
        },
        {
            value: 'INSTALADO',
            label: 'INSTALADO'
        },
        {
            value: 'A REPROGRAMAR',
            label: 'A REPROGRAMAR'
        },
        {
            value: 'PENDIENTE DE ALTA EN SOFTLAND POR VALIDACION DE DOCUMENTACION',
            label: 'PENDIENTE DE ALTA EN SOFTLAND POR VALIDACION DE DOCUMENTACION'
        },
        {
            value: 'SIN LINEA DE VISTA',
            label: 'SIN LINEA DE VISTA'
        },
        {
            value: 'BAJA SEÑAL',
            label: 'BAJA SEÑAL'
        },
        {
            value: 'INFRAESTRUCTURA DEL CLIENTE INADECUADA',
            label: 'INFRAESTRUCTURA DEL CLIENTE INADECUADA'
        },
        {
            value: 'FALTA DE POSTE',
            label: 'FALTA DE POSTE'
        },
        {
            value: 'POSTE EN MAL ESTADO',
            label: 'POSTE EN MAL ESTADO'
        },
        {
            value: 'INSTALACION CANCELADA',
            label: 'INSTALACION CANCELADA'
        },
        {
            value: 'CANCELADO POR FALTA DE DOCUMENTACIÓN',
            label: 'CANCELADO POR FALTA DE DOCUMENTACIÓN'
        },
        {
            value: 'NUEVO PRE-SERVICIO CORPORATIVO',
            label: 'NUEVO PRE-SERVICIO CORPORATIVO'
        },
        {
            value: 'NUEVO PRE-SERVICIO GOBIERNO',
            label: 'NUEVO PRE-SERVICIO GOBIERNO'
        },
        {
            value: 'NO AUTORIZADO - VIP',
            label: 'NO AUTORIZADO - VIP'
        },
        {
            value: 'ACCION SUPEDITADA A ENTIDAD EXTERNA',
            label: 'ACCION SUPEDITADA A ENTIDAD EXTERNA'
        },
        {
            value: 'SIN COBERTURA',
            label: 'SIN COBERTURA',
        }
    ]);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };

    useEffect(() => {
        if(typeof value === 'string') {
            setSelectedValue(options.find((opt) => opt.value === value));
        }else if(Array.isArray(value)){
            setSelectedValue(value.map(va=>{
                const item = options.find(it=>it.value === va);
                if(item){
                    return {
                        value:item.value,
                        label:item.label
                    };
                }
                return null
            }))
        }else{
            setSelectedValue(null);
        }
    }, [options,value]);
    useEffect(() => {
        if(restringir){
            setOptions([
                {
                    value: 'EN ESPERA DE DA',
                    label: 'EN ESPERA DE DA'
                },
                {
                    value: 'FECHA PENDIENTE DE ASIGNAR',
                    label: 'FECHA PENDIENTE DE ASIGNAR'
                },
                {
                    value: 'FECHA ASIGNADA',
                    label: 'FECHA ASIGNADA'
                },
                {
                    value: 'NO LE INTERESA',
                    label: 'NO LE INTERESA'
                },
                {
                    value: 'A REPROGRAMAR',
                    label: 'A REPROGRAMAR'
                },
                {
                    value: 'SIN LINEA DE VISTA',
                    label: 'SIN LINEA DE VISTA'
                },
                {
                    value: 'BAJA SEÑAL',
                    label: 'BAJA SEÑAL'
                },
                {
                    value: 'INFRAESTRUCTURA DEL CLIENTE INADECUADA',
                    label: 'INFRAESTRUCTURA DEL CLIENTE INADECUADA'
                },
                {
                    value: 'FALTA DE POSTE',
                    label: 'FALTA DE POSTE'
                },
                {
                    value: 'POSTE EN MAL ESTADO',
                    label: 'POSTE EN MAL ESTADO'
                },
                {
                    value: 'ACCION SUPEDITADA A ENTIDAD EXTERNA',
                    label: 'ACCION SUPEDITADA A ENTIDAD EXTERNA'
                },
                {
                    value: 'NAP NO DISPONIBLE',
                    label: 'NAP NO DISPONIBLE'
                },
                {
                    value: 'SIN COBERTURA',
                    label: 'SIN COBERTURA',
                },
                {
                    value: 'PRE-SERVICIO DUPLICADO',
                    label: 'PRE-SERVICIO DUPLICADO',
                },
            ])
        }
    }, [restringir])
    useEffect(() => {
        if(negativaRF){
            setOptions([
                {
                    value: 'SIN LINEA DE VISTA',
                    label: 'SIN LINEA DE VISTA'
                },
                {
                    value: 'BAJA SEÑAL',
                    label: 'BAJA SEÑAL'
                },
                {
                    value: 'INFRAESTRUCTURA DEL CLIENTE INADECUADA',
                    label: 'INFRAESTRUCTURA DEL CLIENTE INADECUADA'
                },
            ])
        }
    }, [negativaRF])
    useEffect(() => {
        if(negativaFO){
            setOptions([
                {
                    value: 'ACCION SUPEDITADA A ENTIDAD EXTERNA',
                    label: 'ACCION SUPEDITADA A ENTIDAD EXTERNA'
                },
                {
                    value: 'NAP NO DISPONIBLE',
                    label: 'NAP NO DISPONIBLE'
                },
                {
                    value: 'INFRAESTRUCTURA DEL CLIENTE INADECUADA',
                    label: 'INFRAESTRUCTURA DEL CLIENTE INADECUADA'
                },
            ])
        }
    }, [negativaFO])
    useEffect(() => {
        if(negativaRFSC){
            setOptions([
                {
                    value: 'SIN LINEA DE VISTA',
                    label: 'SIN LINEA DE VISTA'
                },
                {
                    value: 'BAJA SEÑAL',
                    label: 'BAJA SEÑAL'
                },
                {
                    value: 'INFRAESTRUCTURA DEL CLIENTE INADECUADA',
                    label: 'INFRAESTRUCTURA DEL CLIENTE INADECUADA'
                },
                {
                    value: 'SIN COBERTURA',
                    label: 'SIN COBERTURA',
                },
            ])
        }
    }, [negativaRFSC])
    useEffect(() => {
        if(negativaFOSC){
            setOptions([
                {
                    value: 'ACCION SUPEDITADA A ENTIDAD EXTERNA',
                    label: 'ACCION SUPEDITADA A ENTIDAD EXTERNA'
                },
                {
                    value: 'NAP NO DISPONIBLE',
                    label: 'NAP NO DISPONIBLE'
                },
                {
                    value: 'INFRAESTRUCTURA DEL CLIENTE INADECUADA',
                    label: 'INFRAESTRUCTURA DEL CLIENTE INADECUADA'
                },
                {
                    value: 'SIN COBERTURA',
                    label: 'SIN COBERTURA',
                },
            ])
        }
    }, [negativaFOSC])
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (provided) => ({
            ...provided,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? (isDarkMode ? '#90caf9' : '#fff') : isDarkMode ? '#e0e0e0' : '#000',
            background: state.isSelected ? (isDarkMode ? '#1a3a5c' : '#0364ff') : isDarkMode ? '#2d3a52' : '#fff',
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: '#e0e0e0',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: isDarkMode ? '#1a3a5c' : '#0364ff',
                borderRadius: 5,
                border: isDarkMode ? '1px solid #fff' : 'none',
                border: isDarkMode ? '1px solid #fff' : 'none'
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: '#e0e0e0',
            },
        }),
        control: (styles) => ({
            ...styles,
            borderRadius: 7,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        input: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: isDarkMode ? '#b0bec5' : 'gray',
        }),
    }), [isDarkMode])
    return (
        <Select
            {...defaultProps}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isDisabled={disabled}
            isMulti={isMulti}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectEstadoPreServicio.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectEstadoPreServicio;